import type { RouteRecordRaw } from 'vue-router'

import { PAGE_TITLE } from './copy'

// Not engine-scoped: the page lists every engine, so the no-engines notice never covers it,
// and the header shows no selector.
export const routes: RouteRecordRaw[] = [
  {
    path: '/engines',
    name: 'engines',
    component: () => import('./EnginesView.vue'),
    meta: { title: PAGE_TITLE, hideEngineSelector: true },
  },
]
